import { useContext } from "react"

import { EditFieldList } from "web/components"
import { TLOContext } from "web/contexts"

import { useViewable } from "web/hooks/data"
import { useModals } from "web/hooks/modals"

function SettingsModal({ viewType, viewId }) {
  const viewable = useViewable({ type: viewType, id: viewId })

  return (
    <div className="h-full">
      <div className="m-0 h-full overflow-y-auto px-7 py-5">
        <h3 className="font-medium leading-6 text-neutral-4">Fields</h3>
        <div className="mt-3">
          <EditFieldList
            fields={viewable.fields}
            allFields={viewable.available_fields}
          />
        </div>
      </div>
    </div>
  )
}

export default function useSettingsModal({ viewType, viewId }) {
  const { showModal } = useModals()
  const tloContext = useContext(TLOContext) || {}

  return async function () {
    return await showModal({
      title: "Fields",
      fullScreen: false,
      heightPixels: 800,
      widthPixels: 800,
      component: () => (
        <TLOContext.Provider value={tloContext}>
          <SettingsModal viewType={viewType} viewId={viewId} />
        </TLOContext.Provider>
      ),
    })
  }
}
